import * as React from 'react';
import { safe, formatCurrency, isNullOrEmpty } from "../../utils";
import * as moment from "moment";
import { IPageProperties } from "../../models";
import { BackToTop } from "../../assets/BackToTop/BackToTop";
import { Disclaimer, Tooltip } from "../../assets";

const backToTopstyles = require('./overrides/BackToTopoverride.pcss');
const styles = require('./styles.pcss');
export class PageFacts extends React.Component<IPageProperties, {}>{

    constructor(props) {
        super(props);
    }

    render() {
        let { appParams, shareClass } = this.props;
        let { region, clienttype } = appParams;
        if (Object.keys(shareClass).length === 0) {
            return null;
        }
        let [characteristics] = shareClass.statistics.filter(item => item.code === "characteristics");
        if (!characteristics) {
            return null;
        }

        let chars = characteristics.values.filter(item => item["key_fact"] && item["client_type"] === clienttype && item["registration"] === region.toUpperCase());

        let [fundSize] = chars.filter(item => item["label"].toLowerCase().indexOf("fund size") >= 0);
        let [sector] = chars.filter(item => item["label"].toLowerCase().indexOf("comparative sector") >= 0);
        let [share] = chars.filter(item => item["label"].toLowerCase().indexOf("shareclass launch date") >= 0);
        let [holdings] = chars.filter(item => item["label"].toLowerCase().indexOf("number of") >= 0);
        let disclaimers = [];

        return (
            <div className={styles.wrapper}>
                <div className={styles.factsContainer}>
                    <BackToTop styles={backToTopstyles} />
                    <div className={styles.row}>
                        <div className={styles.colXs12}>
                            <h2 className={styles.title + ' ' + styles.reasons}>FUND FACTS</h2>
                        </div>
                    </div>
                    <div className={styles.row + ' ' + styles.padding + ' ' + styles.factBoxRow}>
                        {(() => {
                            if (fundSize) {
                                let [toolTipData] = safe(() => shareClass.disclaimers[`characteristic_definition_${fundSize.key}_${appParams.clienttype}`], []);
                                if (toolTipData) {
                                    fundSize.tooltip = toolTipData.disclaimer;
                                    fundSize.showTooltip = !toolTipData.is_deleted;
                                }
                                disclaimers.push(...shareClass.disclaimers[`characteristic_disclaimer_${fundSize.key}_${appParams.clienttype}`]);
                                return (
                                    <div className={`${styles.colXs12} ${styles.colMd} ${styles.factBox}`}>
                                        <h4>{formatCurrency(safe(() => parseFloat(fundSize["characteristic_value"] as string), 0), "")}</h4>
                                        <p>
                                            {safe(() => fundSize.label, "NO DATA")}&nbsp;
                                            {fundSize.tooltip && fundSize.showTooltip ? <Tooltip text={fundSize.tooltip} /> : ""}
                                            <br />
                                            {safe(() => `(as at ${moment(fundSize.date).format("DD.MM.YYYY")})`, "")}
                                        </p>
                                    </div>
                                );
                            }
                        })()}
                        {(() => {
                            if (sector) {
                                let [toolTipData] = safe(() => shareClass.disclaimers[`characteristic_definition_${sector.key}_${appParams.clienttype}`], []);
                                if (toolTipData) {
                                    sector.tooltip = toolTipData.disclaimer
                                    sector.showTooltip = !toolTipData.is_deleted
                                }
                                disclaimers.push(...shareClass.disclaimers[`characteristic_disclaimer_${sector.key}_${appParams.clienttype}`]);
                                return (
                                    <div className={`${styles.colXs12} ${styles.colMd} ${styles.factBox} ${styles.factBoxSector}`}>
                                        <h4>{safe(() => sector["characteristic_value"], "NO DATA")}</h4>
                                        <p>
                                            {safe(() => sector.label, "NO DATA")}&nbsp;
                                            {sector.tooltip && sector.showTooltip ? <Tooltip text={sector.tooltip} /> : ""}
                                            <br />
                                            {safe(() => `(as at ${moment(sector.date).format("DD.MM.YYYY")})`, "")}
                                        </p>
                                    </div>
                                );
                            }
                        })()}
                        {(() => {
                            if (share) {
                                let [toolTipData] = safe(() => shareClass.disclaimers[`characteristic_definition_${share.key}_${appParams.clienttype}`], []);
                                if (toolTipData) {
                                    share.tooltip = toolTipData.disclaimer
                                    share.showTooltip = !toolTipData.is_deleted
                                }
                                disclaimers.push(...shareClass.disclaimers[`characteristic_disclaimer_${share.key}_${appParams.clienttype}`]);
                                return (
                                    <div className={`${styles.colXs12} ${styles.colMd} ${styles.factBox}`}>
                                        <h4>{moment(safe(() => share["characteristic_value"], moment())).format("DD.MM.YYYY")}</h4>
                                        <p>
                                            {safe(() => share.label, "NO DATA")}&nbsp;
                                            {share.tooltip && share.showTooltip ? <Tooltip text={share.tooltip} /> : ""}
                                        </p>
                                    </div>
                                );
                            }
                        })()}
                        {(() => {
                            if (holdings) {
                                let [toolTipData] = safe(() => shareClass.disclaimers[`characteristic_definition_${holdings.key}_${appParams.clienttype}`], []);
                                if (toolTipData) {
                                    holdings.tooltip = toolTipData.disclaimer
                                    holdings.showTooltip = !toolTipData.is_deleted
                                }
                                disclaimers.push(...shareClass.disclaimers[`characteristic_disclaimer_${holdings.key}_${appParams.clienttype}`]);
                                return (
                                    <div className={`${styles.colXs12} ${styles.colMd} ${styles.factBox}`}>
                                        <h4>{safe(() => holdings["characteristic_value"], "NO DATA")}</h4>
                                        <p>
                                            {safe(() => holdings.label, "NO DATA")}&nbsp;
                                            {holdings.tooltip && !holdings.isDeleted ? <Tooltip text={holdings.tooltip} /> : ""}
                                            <br />
                                            {safe(() => `(as at ${moment(holdings.date).format("DD.MM.YYYY")})`, "")}
                                        </p>
                                    </div>
                                );
                            }
                        })()}
                    </div>
                </div>
                {(() => {
                    let [hasDisclaimers] = disclaimers.filter(item => !item.is_deleted);
                    if (!isNullOrEmpty(disclaimers) && hasDisclaimers) {
                        return (
                            <div className={styles.disclaimer} style={{ textAlign: "left !important" }}>
                                <Disclaimer appParams={appParams} disclaimer={disclaimers}></Disclaimer>
                            </div>
                        );
                    }
                })()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PageFacts/index.tsx